import { Controller } from '@hotwired/stimulus';
import { extract as extractQueryParams } from '@frontend/utils/query-params';
import MatomoTracker from '@frontend/app/features/MatomoTracker';

export default class extends Controller {
  static values = {
    trackMatomoGoalId: { type: Number, default: -1 },
  };

  static targets = [
    'utmCampaignInputField',
    'failureMessage',
    'successMessage',
  ];

  connect() {
    this.form = this.element.querySelector('form');
    this.form.addEventListener('ajax:success', this.handleSuccess.bind(this));
    this.form.addEventListener('ajax:error', this.handleError.bind(this));
    this.form.addEventListener('ajax:before', this.handleBefore.bind(this));
    const utmCampaign = extractQueryParams(window.top.location.href)[
      'utm_campaign'
    ];
    if (utmCampaign) {
      this.utmCampaignInputFieldTarget.value = utmCampaign;
    }
  }

  handleBefore() {
    this.form.hidden = true;
  }

  handleSuccess(event) {
    const [data] = event.detail;
    if (data.status == 'ok') {
      this.successMessageTarget.hidden = false;
      this.successMessageTarget.innerHTML = data.messages.join('. ');
      if (this.hasTrackMatomoGoalIdValue && this.trackMatomoGoalIdValue > 0) {
        MatomoTracker.trackGoal(this.trackMatomoGoalIdValue);
      }
    }
  }

  handleError(event) {
    const [data] = event.detail;
    let failureMessage = '';
    if (data.error_messages) {
      failureMessage = data.error_messages.join('\n<br/>');
    } else {
      failureMessage =
        'Da ist etwas schiefgegangen. Kontaktiere unseren Support.';
    }
    this.failureMessageTarget.hidden = false;
    this.failureMessageTarget.innerHTML = failureMessage;
  }
}
